<div class="back-icon-wrapper">
	<app-icon class="smiles-icon" name="smiles"></app-icon>
</div>


<h2>Staňte se členem naší komunity</h2>
<!-- <p>Zapojte se do diskuzí, vyměňujte si zkušenosti a tipy.<br/>
Pokud píšete články či komentáře, publikujte je na našem webu.</p>
 -->
<p>Pokud chcete v budoucnosti dostávat informace z My na to máme, <br/>
	napište nám na 
	<a class="link" href="mailto:komunita@mynatomame.cz">komunita@mynatomame.cz.</a>
</p>

<!-- <button class="button link">
	<a class="route-link" [routerLink]="'/o-nas/podporte-nas'" >
		<div class="label">
			<span>Porpořte nás</span>
			<span class="under-line-container" ></span>
		</div>
	</a>
</button> -->

<!-- <button class="button">Přihlásit se</button> -->
